import { GameTileProps } from '../../components/modular-grid/types';

type GameType = Pick<GameTileProps, 'jackpotCode' | 'provider'>;

export const groupJackpotGamesByAllowedProviders = (
  games: GameType[],
  allowedProviders: string[] = []
) => {
  const allowedGames = games.filter(
    game =>
      game.jackpotCode &&
      game.provider &&
      allowedProviders.includes(game.provider)
  );
  return allowedGames.reduce((games: Record<string, GameType[]>, game) => {
    if (!game.provider) {
      return games;
    }
    const providerGamesGroup = games[game.provider] || [];
    providerGamesGroup.push(game);
    games[game.provider] = providerGamesGroup;
    return games;
  }, {});
};
